import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  demoConfigService,
  type DemoConfig,
  type ListRecordsResponse,
} from '../services/demoConfig.service';

export function useDemoConfigsList(options?: { page?: number; pageSize?: number }) {
  const { page = 1, pageSize = 100 } = options || {};

  return useQuery<ListRecordsResponse<DemoConfig>>({
    queryKey: ['demoConfigs', page, pageSize],
    queryFn: () => demoConfigService.find({ page, pageSize }),
    staleTime: 30 * 1000,
  });
}

export function useCreateDemoConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: Partial<DemoConfig>) => demoConfigService.create(config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['demoConfigs'] });
    },
  });
}

export function useUpdateDemoConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: Partial<DemoConfig> & { id: string }) => demoConfigService.save(config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['demoConfigs'] });
    },
  });
}

export function useDeleteDemoConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => demoConfigService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['demoConfigs'] });
    },
  });
}
